const VOUCHER_TYPES_WITH_EXPIRATION = new Set([
  "FACTURA PARA CREDITO FISCAL",
  "COMPROBANTE GUBERNAMENTAL",
  "REGIMEN ESPECIAL",
  "NOTA DE CREDITO",
  "NOTA DE DEBITO",
]);

export function normalizeVoucherDescription(description) {
  return (description || "").trim().toUpperCase();
}

export function voucherSupportsExpiration(description) {
  return VOUCHER_TYPES_WITH_EXPIRATION.has(
    normalizeVoucherDescription(description)
  );
}